import { z } from 'zod';

export const Gender = z.enum(['MALE', 'FEMALE', 'NOT_APPLICABLE', 'UNKNOWN']);

export type Gender = z.infer<typeof Gender>;
